import { FOLDER_TRASH_ID, isVirtualFolderNotDefault } from "@zapier/utils";

/**
 * Shared by the Zap kebab and the bulk delete check so both build the same
 * folder permissions request and hit the same react-query cache entry.
 */
export const ZAP_FOLDER_PERMISSION_LEVELS: string[] = [
  "can_edit",
  "can_delete",
];

interface IsZapOwnerPlusInput {
  customuserId: number | undefined;
  zapOwnerId: number | undefined;
  isAccountOwner: boolean;
  isSuperAdmin: boolean;
}

/** Zap owner, account owner and super admin hold every permission on a Zap. */
export function isZapOwnerPlus({
  customuserId,
  zapOwnerId,
  isAccountOwner,
  isSuperAdmin,
}: IsZapOwnerPlusInput): boolean {
  const isZapOwner = customuserId !== undefined && customuserId === zapOwnerId;
  return isZapOwner || isAccountOwner || isSuperAdmin;
}

interface ResolveZapCanDeleteInput {
  folderId: string;
  isDeleted: boolean;
  isMPFEnabled: boolean;
  isOwnerPlus: boolean;
  folderIsShared: boolean;
  folderCanDelete: boolean | undefined;
}

/** Whether the user can move a folder Zap to trash. */
export function resolveZapCanDelete({
  folderId,
  isDeleted,
  isMPFEnabled,
  isOwnerPlus,
  folderIsShared,
  folderCanDelete,
}: ResolveZapCanDeleteInput): boolean {
  const isTrashed = folderId === FOLDER_TRASH_ID || isDeleted;
  if (isVirtualFolderNotDefault(folderId) || isTrashed) {
    return false;
  }

  if (isMPFEnabled) {
    return !!folderCanDelete || isOwnerPlus;
  }

  return folderIsShared || isOwnerPlus;
}
